import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9d6da02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add_tag" }

import TagEditRow from './TagEditRow'
import InputField from '@/components/atoms/InputField'
import IconButton from '@/components/molecules/IconButton'
import i18n from '@/plugins/i18n'
import { CameratagWithCameras } from '@/@types/typescript-axios'
import { computed, ref, withDefaults } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import axios, { AxiosError } from 'axios'
import { ErrorResponse } from '@/@types/typescript-axios'
type tagParam = {
  code: string
  name: string
}

type PropsType = {
  tags?: CameratagWithCameras[] | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TagEditList',
  props: {
    tags: { default: null }
  },
  emits: ["updateCameraList"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateCameraList'): void
}), expose: any, slots: any, attrs: any }) {

const store = useStore()



const newTag = ref<string>('')
const addBtnLoading = ref<boolean>(false)
const disabled = ref<boolean>(false)

const addBtnDisabled = computed<boolean>(() => newTag.value === '')
/**
 * タグの追加
 */
const addTag = async () => {
  addBtnLoading.value = true
  try {
    await store.dispatch('tag/addTag', { tag_name: newTag.value })
    ElMessage({
      message: i18n.global.t('tag_edit_list.added_tag'),
      type: 'success',
    })
    newTag.value = ''
  } catch (error: unknown) {
    if (!axios.isAxiosError(error)) throw error
    showError(error)
  }
  addBtnLoading.value = false
}
/**
 * タグの編集
 * @param {Object} params タグの編集情報
 */
const editTag = async (params: tagParam) => {
  disabled.value = true
  try {
    await store.dispatch('tag/editTag', params)
    ElMessage({
      message: i18n.global.t('tag_edit_list.edited_the_tag'),
      type: 'success',
    })
    // TODO 検索条件を更新はしてないですがカメラ一覧を更新するために実行してます。
    emit('updateCameraList')
  } catch (error: unknown) {
    if (!axios.isAxiosError(error)) throw error
    showError(error)
  }
  disabled.value = false
}
/**
 * タグの削除
 * @param {String} tagCode 削除するタグのtag_code
 */
const deleteTag = async (tagCode: string) => {
  disabled.value = true
  try {
    await store.dispatch('tag/deleteTag', tagCode)
    ElMessage({
      message: i18n.global.t('tag_edit_list.tag_deleted'),
      type: 'success',
    })
    // 検索用route情報も更新為
    emit('updateCameraList')
  } catch (error: unknown) {
    if (!axios.isAxiosError(error)) throw error
    showError(error)
  }
  disabled.value = false
}
/**
 * エラー表示
 * @param {Object} error apiレスポンスのerrorオブジェクト
 */
const showError = (error: AxiosError) => {
  const message = (error.response?.data as ErrorResponse)?.errors?.tag_name[0]
  ElMessage({
    message: message,
    type: 'error',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tag.tag_code
      }, [
        _createVNode(_unref(TagEditRow), {
          tag: tag,
          disabled: disabled.value,
          onEditTag: editTag,
          onDeleteTag: deleteTag
        }, null, 8, ["tag", "disabled"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(InputField), {
        modelValue: newTag.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newTag).value = $event)),
        placeholder: _ctx.$t('tag_edit_list.add_new_tag'),
        name: "newTag",
        disabled: addBtnLoading.value,
        onKeypress: _withKeys(addTag, ["enter"])
      }, null, 8, ["modelValue", "placeholder", "disabled", "onKeypress"]),
      _createVNode(_unref(IconButton), {
        icon: "add",
        iconColor: "color-dark2",
        class: "add_btn",
        disabled: _unref(addBtnDisabled),
        loading: addBtnLoading.value,
        onClick: addTag
      }, null, 8, ["disabled", "loading"])
    ])
  ]))
}
}

})